import React, { useEffect } from "react";
import { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { BankDetailsAPI } from "../api";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/modules/userSlice";
import { useLocation, useParams } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { FormControl } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import FormLabel from "@mui/material/FormLabel";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButtons from "../Model/LoadingButtonModel";
import { InputAdornment } from "@mui/material";
import useDraft from "../../hooks/useDraft";
import { toast } from "react-toastify";
import DraftSavedAt from "../Shared/DraftSavedAt";
import { pickSectionDraftData } from "../../drafts/draftHelpers";

function SectionD({ changeTab, handleButtonClick }) {
  const { user } = useSelector(selectUser);

  const initialState = {
    userId: user.isAdmin ? id : user._id,
    isIcici: true,
    accountNumber: "",
    branch: "",
    ifscCode: "",
    passbook: "",
    passbook_filename: "",
  };

  const [bankDetails, setBankDetails] = useState(initialState);
  const params = useParams();
  const id = params.id ? params.id : "";
  const { loadDraft, saveDraft, deleteDraft, saving: draftSaving, lastDraftedAt } = useDraft(
    "newJoinee",
    "D",
  );
  const [newJoineeSectionDFlagButton, setNewJoineeSectionDFlagButton] =
    useState("");
  const [sign, setSign] = useState(true);
  const [fileName, setFileName] = useState(null);
  const [fileError, setFileError] = useState(false);
  const [error, setError] = useState({
    accountNumber: false,
    ifscCode: false,
  });
  const [loadingbutton, setLoadingButton] = useState(false);

  useEffect(() => {
    let isActive = true;

    (async () => {
      let draftApplied = false;

      if (!user.isAdmin) {
        const loadedDraft = await loadDraft();
        const draftData = loadedDraft && loadedDraft.data ? loadedDraft.data : null;
        const payload =
          draftData &&
          draftData.bankDetails &&
          draftData.bankDetails.bankDetails &&
          typeof draftData.bankDetails.bankDetails === "object"
            ? draftData.bankDetails.bankDetails
            : null;
        if (isActive && payload) {
          setBankDetails((prev) => ({ ...prev, ...payload }));
          payload.passbook_filename ? setSign(false) : setSign(true);
          setFileName(payload.passbook_filename || null);
          draftApplied = true;
        }
      }

      BankDetailsAPI.getBankDetails(user.isAdmin ? id : user._id).then((res) => {
        if (!isActive) return;
        if (!draftApplied && res.data) {
          setBankDetails(res.data);
          res.data.passbook_filename ? setSign(false) : setSign(true);
          setFileName(res.data.passbook_filename);
        }
        setNewJoineeSectionDFlagButton(
          res ? res.userData.isNewJoineeFormComplete : ""
        );
      });
    })();

    return () => {
      isActive = false;
    };
  }, [id, loadDraft, user._id, user.isAdmin]);

  const handleSaveDraft = async () => {
    if (user.isAdmin) return;
    const draftable = {
      ...bankDetails,
      passbook_filename: bankDetails.passbook_filename || fileName || "",
    };
    const wrapped = pickSectionDraftData("newJoinee", "D", { bankDetails: draftable });
    const saved = await saveDraft(wrapped);
    if (saved && saved.skipped) {
      toast.info("Nothing to save as draft");
      return;
    }
    if (saved) toast.success("Draft saved");
    else toast.error("Unable to save draft");
  };

  const [validateerror, setvalidateerror] = useState([
    { accountNumber: "", status: false },
    { branch: "", status: false },
    { ifscCode: "", status: false },
  ]);
  const validatehandler = () => {
    const arr = [
      bankDetails.accountNumber,
      bankDetails.branch,
      bankDetails.ifscCode,
    ];
    var arrName = ["accountNumber", "branch", "ifscCode"];
    const keyObj = [];
    for (let i = 0; i < arr.length; i++) {
      if (!arr[i]) {
        keyObj.push({
          name: arrName[i],
          status: true,
        });
      } else {
        keyObj.push({
          name: arrName[i],
          status: false,
        });
      }
    }
    setvalidateerror(keyObj);
    const check = arr.every((e) => e);
    return check;
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const maxSizeInBytes = 1000 * 1024;
    if (!file) return;
    if (file.size > maxSizeInBytes) {
      toast.error("File size exceeds the 1000 KB limit", {
        hideProgressBar: true,
        closeOnClick: true,
      });
      return;
    }
    setFileName(file.name);
    const reader = new FileReader();

    reader.onload = (e) => {
      const imageDataURL = e.target.result;
      setBankDetails((prev) => ({
        ...prev,
        passbook: imageDataURL,
        passbook_filename: file.name,
      }));
    };

    setSign(false);

    reader.readAsDataURL(file);
    setFileError(false);
  };

  const handleSign = () => {
    setBankDetails({ ...bankDetails, passbook: "", passbook_filename: "" });
    setFileName(null);
    setSign(true);
  };

  const handleChange1 = (e) => {
    const { value } = e.target;
    if (value.length !== 12) {
      setError({ ...error, accountNumber: true });
    } else {
      setError({ ...error, accountNumber: false });
    }
    setBankDetails({ ...bankDetails, accountNumber: value });

    if (validateerror) {
      const validateAccountNumber = [...validateerror];
      validateAccountNumber[0].status = false;
      setvalidateerror(validateAccountNumber);
    }
  };

  const handleChange2 = (e, field) => {
    const { value } = e.target;
    setBankDetails({ ...bankDetails, [field]: value });

    if (validateerror) {
      const validateBranch = [...validateerror];
      validateBranch[1].status = false;
      setvalidateerror(validateBranch);
    }
  };

  const handleChange3 = (e) => {
    const { value } = e.target;
    if (value.length < 7) {
      setError({ ...error, ifscCode: true });
    } else {
      setError({ ...error, ifscCode: false });
    }
    if (value.length <= 11 && value.trim) {
      setBankDetails({ ...bankDetails, ifscCode: value });
    }

    if (validateerror) {
      const validateifscCode = [...validateerror];
      validateifscCode[2].status = false;
      setvalidateerror(validateifscCode);
    }
  };

  const validate = () => {
    let userDest = { ...bankDetails };

    if (userDest.ifscCode.length < 7) {
      setError({ ...error, ifscCode: true });
      return;
    } else {
      return true;
    }
  };

  const handleSubmit = () => {
    if (bankDetails.isIcici) {
      if (validatehandler() && validate()) {
        handleButtonClick("sectionD");
        const userDest = { ...bankDetails };

        userDest["passbook_filename"] = fileName
          ? fileName
          : bankDetails.passbook_filename;
        if (!fileName) {
          setFileError(true);
          return;
        }
        setLoadingButton(true);
        if (bankDetails._id) {
          BankDetailsAPI.updateBankDetails(
            user.isAdmin ? id : bankDetails._id,
            userDest
          )
            .then(async (res) => {
              setLoadingButton(false);
              if (!user.isAdmin) await deleteDraft();
              changeTab(4);
            })
            .catch((err) => {
              setTimeout(() => {
                setLoadingButton(false);
              }, 10000);
              console.log(err);
            });
        } else {
          BankDetailsAPI.createBankDetails(userDest)
            .then(async (res) => {
              if (!user.isAdmin) await deleteDraft();
              changeTab(4);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
      return;
    }
    if (!bankDetails.isIcici) {
      handleButtonClick("sectionD");
      if (bankDetails._id) {
        BankDetailsAPI.updateBankDetails(
          user.isAdmin ? id : bankDetails._id,
          bankDetails
        )
          .then(async (res) => {
            if (!user.isAdmin) await deleteDraft();
            changeTab(4);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        BankDetailsAPI.createBankDetails(bankDetails)
          .then(async (res) => {
            if (!user.isAdmin) await deleteDraft();
            changeTab(4);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const handleCheckBox = (e) => {
    if (e.target.checked == true) {
      let tempDetails = { ...bankDetails };
      tempDetails.accountNumber = "";
      tempDetails.branch = "";
      tempDetails.isIcici = false;
      tempDetails.ifscCode = "";
      setBankDetails({ ...tempDetails });
    } else
      setBankDetails({
        ...bankDetails,
        isIcici: e.target.checked == true ? false : true,
      });
  };

  return (
    <div>
      <div className={`col-12 ${user.isAdmin ? "" : "my-5"}`}>
        <div>
          <h3>
            <span>Bank Details</span>
          </h3>
        </div>
        <section className="col-12 py-4">
          <div className="mb-4">
            <h5>
              <span>Add Only ICICI Bank Detail</span>
            </h5>
          </div>
          <div className="">
            <Box sx={{ width: "100%" }}>
              <Grid container spacing={3} sx={{ marginBottom: "2%" }}>
                <Grid item>
                  <TextField
                    sx={{ width: "35ch" }}
                    label="Account Number"
                    type="number"
                    value={bankDetails.accountNumber}
                    error={validateerror ? validateerror[0].status : ""}
                    onChange={(e) => handleChange1(e)}
                    required={!bankDetails.isIcici}
                    helperText={error.accountNumber ? "Invalid Number" : ""}
                    disabled={
                      !bankDetails.isIcici ||
                      (user.isAdmin &&
                        (newJoineeSectionDFlagButton === "pending" ||
                          newJoineeSectionDFlagButton === "submitted" ||
                          newJoineeSectionDFlagButton === "review done" ||
                          newJoineeSectionDFlagButton ===
                            "resubmission required"))
                    }
                  />
                </Grid>
                <Grid item>
                  <TextField
                    sx={{ width: "35ch" }}
                    label="Bank"
                    value="ICICI BANK"
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item>
                  <TextField
                    sx={{ width: "35ch" }}
                    label="Branch"
                    value={bankDetails.branch}
                    error={validateerror ? validateerror[1].status : ""}
                    onChange={(e) => handleChange2(e, "branch")}
                    required={!bankDetails.isIcici}
                    disabled={
                      !bankDetails.isIcici ||
                      (user.isAdmin &&
                        (newJoineeSectionDFlagButton === "pending" ||
                          newJoineeSectionDFlagButton === "submitted" ||
                          newJoineeSectionDFlagButton === "review done" ||
                          newJoineeSectionDFlagButton ===
                            "resubmission required"))
                    }
                  />
                </Grid>
                <Grid item>
                  <TextField
                    sx={{ width: "35ch" }}
                    label="IFSC Code"
                    value={bankDetails.ifscCode}
                    InputProps={{
                      readOnly: true,
                      startAdornment: (
                        <InputAdornment position="start">ICIC</InputAdornment>
                      ),
                    }}
                    inputProps={{
                      maxLength: 7,
                      readOnly: false,
                    }}
                    error={validateerror ? validateerror[2].status : ""}
                    required={!bankDetails.isIcici}
                    onChange={(e) => handleChange3(e)}
                    helperText={error.ifscCode ? "Invalid IFSC Code" : ""}
                    disabled={
                      !bankDetails.isIcici ||
                      (user.isAdmin &&
                        (newJoineeSectionDFlagButton === "pending" ||
                          newJoineeSectionDFlagButton === "submitted" ||
                          newJoineeSectionDFlagButton === "review done" ||
                          newJoineeSectionDFlagButton ===
                            "resubmission required"))
                    }
                  />
                </Grid>
              </Grid>

              <div className="mb-4" style={{ marginTop: "15px" }}>
                <h5>
                  <span>Upload a copy of your checque</span>
                </h5>
              </div>
              {sign ? (
                <Button
                  sx={{ width: "200px", fontSize: "12px", marginTop: "25px" }}
                  variant="contained"
                  component="label"
                >
                  <b>Upload File</b>

                  <input
                    onChange={(e) => handleImageUpload(e)}
                    hidden
                    accept="image/*"
                    type="file"
                    disabled={
                      !bankDetails.isIcici ||
                      (user.isAdmin &&
                        (newJoineeSectionDFlagButton === "pending" ||
                          newJoineeSectionDFlagButton === "submitted" ||
                          newJoineeSectionDFlagButton === "review done" ||
                          newJoineeSectionDFlagButton ===
                            "resubmission required"))
                    }
                  />
                </Button>
              ) : (
                <div className="my-3">
                  <span>{bankDetails.passbook_filename || fileName}</span>
                  <CloseIcon sx={{ marginLeft: "10px" }} onClick={handleSign} />
                </div>
              )}
              {fileError && (
                <div
                  style={{ fontSize: "17px", marginTop: "5px", color: "red" }}
                >
                  <span>Please Upload a copy of your checque </span>
                </div>
              )}
            </Box>
          </div>
        </section>
        <div className="col-12 ms-2 mb-2 border-bottom border-2"></div>
        <div className="col-12 mb-2 px-3 sudexoclass">
          <FormControlLabel
            checked={!bankDetails.isIcici}
            onChange={(e) => handleCheckBox(e)}
            control={<Checkbox />}
            label="I don’t have ICICI Account"
          />
        </div>
        <div className="col-12 ms-2 mb-2 border-bottom border-2"></div>
        {newJoineeSectionDFlagButton === "review done" ||
        ((newJoineeSectionDFlagButton === "pending" ||
          newJoineeSectionDFlagButton === "submitted" ||
          newJoineeSectionDFlagButton === "resubmission required") &&
          user.isAdmin) ? (
          ""
        ) : (
          <div className="d-flex align-items-center" style={{ marginTop: "140px" }}>
            <div className="d-flex align-items-center">
              {!user.isAdmin && (
                <button
                  type="button"
                  onClick={() => handleSaveDraft()}
                  className="btn btn-outline-primary btn-lg px-5 me-4"
                  disabled={draftSaving}
                >
                  Save Draft
                </button>
              )}
              {loadingbutton ? (
                <div className="me-4">
                  <LoadingButtons />
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => handleSubmit()}
                  className="btn btn-primary btn-lg px-5 me-4"
                >
                  Save
                </button>
              )}
              <button
                type="button"
                onClick={() => setBankDetails(initialState)}
                className="btn btn-outline-primary btn-lg px-5"
              >
                Clear All
              </button>
            </div>

            {!user.isAdmin ? (
              <DraftSavedAt className="ms-auto" date={lastDraftedAt} />
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}

export default SectionD;
